import { COLORS } from '@stitch-fix/mode-react';
import { media } from '../../pages/product/[productSlug]/[externalProductId]/components/ProductImageGallery/mockData';
import type { MiniPdpImage, MiniPdpProduct } from './MiniPdpModal.types';
export const mockMedia: MiniPdpImage[] = media.map(image => ({
  src: image.originalSrc.replace('/upload/', `/upload/f_auto,q_auto,w_800/${image.group === 'figure_image' ? '' : `e_replace_color:${COLORS['gray-95'].replace('#', '')}:300:ffffff/`}`),
  alt: image.altText
}));
export const mockPaymentOptions: NonNullable<MiniPdpProduct['paymentOptions']> = {
  installmentPaymentsLabel: '4 interest-free payments of $25.00',
  buyNowPayLaterHelpContent: {
    helpIcon: 'INFORMATION',
    helpModuleHeaderCopy: {
      plain: 'Buy now, pay later',
      formatted: 'Buy now, pay later'
    },
    helpModuleBodyCopy: {
      plain: 'Payment options and eligibility are shown at checkout.',
      formatted: 'Payment options and eligibility are shown at checkout.',
      links: []
    },
    paymentOptionIcons: ['PAYMENT_AFTERPAY', 'PAYMENT_AFFIRM', 'PAYMENT_KLARNA'],
    paymentOptionIconsForPriceLabel: ['PAYMENT_AFTERPAY_BLACK', 'PAYMENT_AFFIRM_BLACK', 'PAYMENT_KLARNA_BLACK']
  }
};

// Reuse the regular PDP's Cloudinary fixture, including front, back, detail,
// flat product, and style-card images. Match the page's gray flat-image treatment.
export const mockProduct: MiniPdpProduct = {
  sku: 'mini-pdp-jeans',
  brand: 'Brand',
  name: 'Kaylee Skinny Colored Jean',
  price: '$100.00',
  colorName: 'Olive',
  size: 'M',
  media: mockMedia,
  materialsAndCare: 'See the garment label for materials and care instructions.',
  productDetails: 'Skinny colored jeans in Olive.',
  paymentOptions: mockPaymentOptions
};